import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colorBlue } from '@/utils/palette';
import { left } from '@/utils/directions';
import { API } from '@/redux/config';

const NavbarProfilePicture = ({ user }) => {
  const [userFullName, setUserFullName] = useState(user?.fullname);
  const [initials, setInitials] = useState('');

  const pictureSet = user?.logo?.[0] === 'h';
  const [profilePic, setProfilePic] = useState(null);

  useEffect(() => {
    async function fetchImagePreview() {
      if (user?.logo) {
        const link = `/sharepoint/image_preview?link=${user?.logo}`;
        const response = await API.get(link, { responseType: 'blob' });
        setProfilePic(response?.data);
      }
    }
    fetchImagePreview();
  }, [user?.logo]);

  useEffect(() => {
    setUserFullName(user?.fullname);
  }, [user]);

  useEffect(() => {
    setInitials(userFullName?.charAt(0).toUpperCase());
  }, [userFullName]);

  return (
    <ActivityEntryAvatar>
      <ProfileAvatar style={{ background: `#${user?.logo}` }}>
        {pictureSet && !!profilePic ? (
          <Image
            src={URL.createObjectURL(profilePic)}
            alt='#'
            loading='lazy'
            key={profilePic.id}
          />
        ) : (
          <ProfileInitials>{initials}</ProfileInitials>
        )}
      </ProfileAvatar>
    </ActivityEntryAvatar>
  );
};

export default NavbarProfilePicture;

const ProfileAvatar = styled.div`
  margin: auto 0;
  border-radius: 50%;
  height: 36px;
  width: 36px;
  background: ${colorBlue};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProfileInitials = styled.div`
  font-size: 15px;
  color: #fff;
  text-align: ${left};
`;

const ActivityEntryAvatar = styled.div`
  margin-top: 13px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  min-width: 36px;
  margin-right: 8px;

  img {
    height: 100%;
    width: 100%;
    margin: 0;
  }
`;

const Image = styled.img`
  display: block;
  width: 250px;
  height: 250px;
`;
